"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKOUT_ORDER = exports.GET_NODE_INFO_WINDOW = exports.NODE_RECENTLY_BROWSED = exports.GET_SPECIFY_NODE_LIST = exports.DATASHEET_FOREIGN_FORM = exports.FAVORITE_NODE_LIST = exports.MOVE_FAVORITE_NODE = exports.UPDATE_NODE_FAVORITE_STATUS = exports.TRASH_DELETE = exports.TRASH_RECOVER = exports.TRASH_LIST = exports.ADD_ROLE = exports.BATCH_DELETE_ROLE = exports.BATCH_EDIT_ROLE = exports.EDIT_ROLE = exports.NODE_LIST_ROLE = exports.DELETE_ROLE = exports.DISABLE_ROLE_EXTEND = exports.ENABLE_ROLE_EXTEND = exports.COMMIT_REMIND = exports.NODE_SHOWCASE = exports.UPDATE_SHARE = exports.STORE_SHARE_DATA = exports.READ_SHARE_INFO = exports.CHANGE_NODE_DESC = exports.SHARE_SETTINGS = exports.REGENERATE_SHARE_LINK = exports.DISABLE_SHARE = exports.UPDATE_ROLE = exports.NODE_NUMBER = exports.IMPORT_FILE = exports.SEARCH_NODE = exports.FIND_NODE = exports.POSITION_NODE = exports.KEEP_TAB_BAR = exports.GET_DST_ID = exports.COPY_NODE = exports.EDIT_NODE = exports.DELETE_NODE = exports.ADD_NODE = exports.MOVE_NODE = exports.SELECTBYPARENTID = exports.GET_NODE_INFO = exports.GET_NODE_TREE = exports.GET_PARENTS = exports.ALLOW_VISIBLE_SETTING = exports.GET_NODE_LIST = exports.GET_ROOT_NODE = void 0;
// =============== Node related =======================
// get the root node
exports.GET_ROOT_NODE = '/node/root';
// Query the list of child nodes
exports.GET_NODE_LIST = '/node/children';
// Get whether you can manage the visible state of all members
exports.ALLOW_VISIBLE_SETTING = '/node/allowManageWorkbenchSetting';
// Query the chain from parent node to root node
exports.GET_PARENTS = '/node/parents';
// Query the node tree of the workbench, limit the query to two layers
exports.GET_NODE_TREE = '/node/tree';
// Query node information
exports.GET_NODE_INFO = '/node/get';
// Query the child node to which it belongs based on the parent node id
exports.SELECTBYPARENTID = '/node/selectByParentId/';
// move node
exports.MOVE_NODE = '/node/move';
// add node
exports.ADD_NODE = '/node/create';
// delete node
exports.DELETE_NODE = '/node/delete/';
// edit node
exports.EDIT_NODE = '/node/update/';
// copy node
exports.COPY_NODE = '/node/copy';
// Get the table ID
exports.GET_DST_ID = '/node/getDstId/';
// record active table tab
exports.KEEP_TAB_BAR = '/node/active';
// directory tree location
exports.POSITION_NODE = '/node/position/';
// retrieve node
// TODO: to be discarded
exports.FIND_NODE = '/node/select';
// search node
exports.SEARCH_NODE = '/node/search';
// import datasheet
exports.IMPORT_FILE = '/node/import';
// Get the number of folders and files
exports.NODE_NUMBER = '/node/count';
// modify the character
exports.UPDATE_ROLE = '/node/updateRole';
// close node sharing
exports.DISABLE_SHARE = '/node/disableShare/';
// Refresh the node share link
exports.REGENERATE_SHARE_LINK = '/node/regenerateShareLink/';
// Get node sharing settings
exports.SHARE_SETTINGS = '/node/shareSettings/';
// update node description
exports.CHANGE_NODE_DESC = '/node/updateDesc';
// Get the information of the shared node
exports.READ_SHARE_INFO = '/node/readShareInfo';
// dump node
exports.STORE_SHARE_DATA = '/node/storeShareData';
// Change node sharing settings
exports.UPDATE_SHARE = '/node/updateShare/';
exports.NODE_SHOWCASE = '/node/showcase';
// Member field mentions other records
exports.COMMIT_REMIND = '/node/remind';
// Enable node inheritance mode
exports.ENABLE_ROLE_EXTEND = '/node/enableRoleExtend';
// Turn off node inheritance mode
exports.DISABLE_ROLE_EXTEND = '/node/disableRoleExtend';
// delete node role
exports.DELETE_ROLE = '/node/deleteRole';
// Query the list of node roles
exports.NODE_LIST_ROLE = '/node/listRole';
// Modify the role of the node's organizational unit
exports.EDIT_ROLE = '/node/editRole';
// Batch modify node permissions
exports.BATCH_EDIT_ROLE = '/node/batchEditRole';
// delete node permissions
exports.BATCH_DELETE_ROLE = 'node/batchDeleteRole';
// Add the organizational unit of the specified role of the node
exports.ADD_ROLE = '/node/addRole';
// Query the node list of the recycle bin
exports.TRASH_LIST = '/node/rubbish/list';
// restore node
exports.TRASH_RECOVER = '/node/rubbish/recover';
// delete the node from the recycle bin
exports.TRASH_DELETE = '/node/rubbish/delete/';
// Change the node collection state
exports.UPDATE_NODE_FAVORITE_STATUS = '/node/favorite/updateStatus/';
// Move the collection node position
exports.MOVE_FAVORITE_NODE = '/node/favorite/move';
// Query the list of favorite nodes
exports.FAVORITE_NODE_LIST = '/node/favorite/list';
// Query the magic form/mirror associated with the data table node
exports.DATASHEET_FOREIGN_FORM = '/node/getRelNode';
// Get the node of the specified type in the directory tree
exports.GET_SPECIFY_NODE_LIST = '/node/list';
// =============== Node related =======================
// recently browsed folder
exports.NODE_RECENTLY_BROWSED = '/node/recentList';
// Get node information - file information window
exports.GET_NODE_INFO_WINDOW = 'node/window';
exports.CHECKOUT_ORDER = '/checkout';
//# sourceMappingURL=url.node.js.map